import {isApolloError} from '@apollo/client/errors';
import type {OperationVariables} from '@apollo/client/core';
import type {UseQueryReturn} from '@vue/apollo-composable';
import {createError} from '#imports';

export async function toAsyncQuery<T extends UseQueryReturn<unknown, OperationVariables>>(query: T): Promise<T> {
  try {
    await new Promise((resolve, reject) => {
      query.onResult((result: { loading: boolean }) => {
        if (!result.loading) {
          resolve(true);
        }
      });

      query.onError(reject);
    });
  } catch (e) {
    if (e instanceof Error && isApolloError(e) && e.graphQLErrors?.some(error => error.extensions?.category === 'authorization')) {
      throw createError({
        statusCode: 403,
      });
    }

    throw e;
  }

  return query;
}

